import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isValidMetrics } from '../../entities/Metrics';
import { BaseClient } from '../BaseClient';
export class MetricsClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getMetricsByDateImpl", void 0);
  }
  async getMetrics(dates) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        metric
      } = await this.request(this.getMetricsByDateImpl({
        startDate: dates.startDate,
        endDate: dates.endDate
      }), ...args);
      return this.convertToEntity(metric);
    } catch (error) {
      this.logError('getMetrics', 'Failed to get metrics', {
        dates
      }, error);
      throw error;
    }
  }
  convertToEntity(metrics) {
    try {
      if (!metrics) {
        throw new Error('Invalid metrics', {
          cause: {
            metrics
          }
        });
      }
      const {
        clientsReachedOut,
        recurringVisitsBooked,
        tasksBeingHandled,
        clientReachedOutViaLink,
        recurringSchedulesCreated
      } = metrics || {};
      const convertedMetrics = {
        clientsReachedOut,
        recurringVisitsBooked,
        tasksBeingHandled,
        clientReachedOutViaLink,
        recurringSchedulesCreated
      };
      if (isValidMetrics(convertedMetrics)) {
        return convertedMetrics;
      }
      throw new Error('Invalid metrics data', {
        cause: {
          metrics
        }
      });
    } catch (error) {
      this.logError('convertToEntity', 'Failed to convert metrics', {
        metrics
      }, error);
      throw error;
    }
  }
  getServiceNameForLogs() {
    return 'MetricsClient';
  }
}
//# sourceMappingURL=MetricsClientBase.js.map